const a = {
  name: "--pf-v6-c-brand--Width"
};
export {
  a as c_brand_Width,
  a as default
};
